import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { FaThLarge } from "react-icons/fa";
import { Seller } from "../Components";
import { LineWave } from "react-loader-spinner";
import apiClient from "../Config/apiConfig";
const config = {
    BASE_URL: "https://admin.thezeeshangroup.com/",
};
const PropertyDetails = () => {
    let { url } = useParams();
    const [getPropertiesData, setGetFeaturedPropertiesData] = useState([]);
    const [loader, setLoader] = useState(true);
    const featuredpropertiesApi = async () => {
        try {
            const res = await apiClient.get(`api/featured-propertie/` + url);
            setLoader(true);
            setGetFeaturedPropertiesData(res.data);
            setLoader(false);
        } catch (error) {
            console.log(error.message);
        }
    };
    useEffect(() => {
        featuredpropertiesApi();
    }, []);
    return (
        <>
            {loader ? (
                <div className="d-flex justify-content-center">
                    <LineWave
                        height="250"
                        width="150"
                        color="#56b13d"
                        ariaLabel="line-wave"
                    />
                </div>
            ) : (
                getPropertiesData && (
                    <div>
                        <div className="title-bar-wrapper">
                            <Container>
                                <Row>
                                    <div className="title">
                                        <h1>{getPropertiesData?.name}</h1>
                                    </div>
                                    <ul className="bread-crumb pull-right">
                                        <li>
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li>-</li>
                                        <li>{getPropertiesData?.name}</li>
                                    </ul>
                                </Row>
                            </Container>
                        </div>
                        <div className="inner-page-bg">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8">
                                        <div className="row">
                                            {getPropertiesData?.gallery_images?.length > 0 && getPropertiesData?.gallery_images?.map((image, j) => {
                                                return (
                                                    image && image != "" && (<div className="col-md-4">
                                                        <div className="property-img">
                                                            <img src={`${config.BASE_URL}uploads/featuredproperties/${image}`} alt="" />
                                                        </div>
                                                    </div>)

                                                );
                                            })}
                                        </div>
                                        <div className="why-projects">
                                            <div className="why-projects-title">
                                                <h2>Why Zeeshan {getPropertiesData?.name}?</h2>
                                                <div className="why-projects-dec" dangerouslySetInnerHTML={{ __html: getPropertiesData?.why_fp }} />


                                            </div>
                                        </div>
                                        <div className="overview-details">
                                            <h2>Zeeshan {getPropertiesData?.name} Overview</h2>
                                            <div className="overview-main">
                                                <div className="row">
                                                    <div className="col-lg-4">
                                                        <div className="overview-single d-flex align-items-center">
                                                            <div className="overview-icon">
                                                                <FaThLarge />
                                                            </div>
                                                            <div>
                                                                <span>Project Area</span>
                                                                <p className="mb-0">{getPropertiesData?.project_area}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="overview-single d-flex align-items-center">
                                                            <div className="overview-icon">
                                                                <FaThLarge />
                                                            </div>
                                                            <div>
                                                                <span>Sizes</span>
                                                                <p className="mb-0">{getPropertiesData?.sizes}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="overview-single d-flex align-items-center">
                                                            <div className="overview-icon">
                                                                <FaThLarge />
                                                            </div>
                                                            <div>
                                                                <span>Project Size</span>
                                                                <p className="mb-0">{getPropertiesData?.project_sizes}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="overview-single d-flex align-items-center">
                                                            <div className="overview-icon">
                                                                <FaThLarge />
                                                            </div>
                                                            <div>
                                                                <span>Avg. Price</span>
                                                                <p className="mb-0">{getPropertiesData?.avg_price}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="overview-single d-flex align-items-center">
                                                            <div className="overview-icon">
                                                                <FaThLarge />
                                                            </div>
                                                            <div>
                                                                <span>Possession Startse</span>
                                                                <p className="mb-0">{getPropertiesData?.possession_startse}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="overview-single d-flex align-items-center">
                                                            <div className="overview-icon">
                                                                <FaThLarge />
                                                            </div>
                                                            <div>
                                                                <span>Configurations</span>
                                                                <p className="mb-0">{getPropertiesData?.configurations}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="group-all-btn">
                                                    {getPropertiesData?.link_99 ? (
                                                        <Link
                                                            to={getPropertiesData?.link_99}
                                                            target="_blank"
                                                        >
                                                            View as 99
                                                        </Link>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {getPropertiesData?.magic_bricks_link ? (
                                                        <Link
                                                            to={getPropertiesData?.magic_bricks_link}
                                                            target="_blank"
                                                        >
                                                            View as Magic Bricks
                                                        </Link>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {getPropertiesData?.other_link ? (
                                                        <Link
                                                            to={getPropertiesData?.other_link}
                                                            target="_blank"
                                                        >
                                                            View as Housing.com
                                                        </Link>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {getPropertiesData?.olx_link ? (
                                                        <Link
                                                            to={getPropertiesData?.olx_link}
                                                            target="_blank"
                                                        >
                                                            View as OLX
                                                        </Link>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="overview-details">
                                            <h2>About Zeeshan {getPropertiesData?.name}</h2>
                                            <div className="overview-main about-for-project" dangerouslySetInnerHTML={{ __html: getPropertiesData?.fp_about }} />

                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <Seller />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                )
            )}
        </>
    );
};

export default PropertyDetails;
